import { render, staticRenderFns } from "./UitpekelItemCombo.vue?vue&type=template&id=740c89e9&scoped=true"
import script from "./UitpekelItemCombo.vue?vue&type=script&lang=js"
export * from "./UitpekelItemCombo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740c89e9",
  null
  
)

export default component.exports